const KEY = "presence_sidebar";

export function readPresenceSidebarSlim(): boolean {
  try {
    return localStorage.getItem(KEY) === "slim";
  } catch {
    return false;
  }
}

export function persistPresenceSidebarSlim(slim: boolean): void {
  try {
    localStorage.setItem(KEY, slim ? "slim" : "open");
  } catch {
    /* ignore */
  }
}
